export const removeDuplicatesByProperty = <ObjectType, RequiredProperty extends keyof ObjectType>(
  array: ObjectType[],
  propertyName: RequiredProperty
) =>
  array.filter(
    (item, index) => array.findIndex((itemToFind) => itemToFind[propertyName] === item[propertyName]) === index
  );
